import { Nut, Wheat, Fish, Shell, Milk, Egg, Bean, Coffee, Sprout, CircleDot, Droplet } from "lucide-react";

const Mushroom = ({ className, strokeWidth = 1.5 }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M3 12a9 7 0 0 1 18 0z" />
    <path d="M9.5 12v6a2.5 2.5 0 0 0 5 0v-6" />
  </svg>
);

export const ALLERGEN_META = {
  "Tree nuts": { icon: Nut, label: "Tree nuts" },
  Peanut: { icon: Nut, label: "Peanut" },
  Sesame: { icon: CircleDot, label: "Sesame" },
  Soy: { icon: Bean, label: "Soy" },
  Fish: { icon: Fish, label: "Fish" },
  Crustacean: { icon: Shell, label: "Crustacean" },
  Gluten: { icon: Wheat, label: "Gluten" },
  Dairy: { icon: Milk, label: "Dairy" },
  Egg: { icon: Egg, label: "Egg" },
  Mustard: { icon: CircleDot, label: "Mustard" },
  Celery: { icon: Sprout, label: "Celery" },
  Sulphites: { icon: Droplet, label: "Sulphites" },
  Mushroom: { icon: Mushroom, label: "Mushroom" },
  Seeds: { icon: Sprout, label: "Seeds" },
  Caffeine: { icon: Coffee, label: "Caffeine" },
  Coconut: { icon: Droplet, label: "Coconut (info)" },
};

export const COURSES = [
  { key: "broth", label: "Broths" },
  { key: "starter", label: "Small Plates" },
  { key: "main", label: "Large Plates" },
  { key: "dessert", label: "Desserts" },
];

export const DIET_LABEL = { vegan: "Vegan", vegetarian: "Vegetarian", "non-veg": "Non-veg" };

export const TASTE_LABEL = { light: "Light", comforting: "Comforting", mild: "Mild", bold: "Bold" };

export const slugKey = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

export const CROSS_CONTACT = "Our kitchen handles nuts, sesame, soy, dairy, gluten, shellfish and other allergens. We can't guarantee any dish is free from traces. Please tell your server about allergies.";
export const TAX_NOTE = "Govt. taxes as applicable";
export const kcalLabel = (k) => `~${k} kcal`;
